import { PlusOutlined } from "@ant-design/icons";
import { Modal, Button, Input, Form, Select } from "antd";
import TagNumber from "../TagNumber";
import { useForm } from "antd/es/form/Form";
import { FormInstance, FormProps } from "antd/lib";
import { useEffect, useRef, useState } from "react";
import '../NotificationFeesSetting.scss';
import { addNotificationCosts } from "../../../api/network/networkApi";
import { ITypeZNS } from "../../../api/selectOption/selectOptionsApi";
import { fommatSelectOption, normalizeNumberInput, validatePositiveNumberMax12 } from "../../../until";
import { MAX_DIGITS } from "../../../env";

interface Props {
  isOpen: boolean
  listTypeZNS: ITypeZNS[]

  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
  closeModal: () => void
}

const ModalAddTemplateZNS: React.FC<Props> = ({
  isOpen, listTypeZNS,
  onSubmitFormModal, closeModal
}) => {
  const [form] = useForm();
  const formRef = useRef<FormInstance<any>>(null);



  const submitForm = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    const { chiPhi, ZNSId } = values
    const result = await addNotificationCosts(
      Number(chiPhi.replaceAll(".", "")), 2, undefined, undefined, ZNSId
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result.message)
    } else {
      onSubmitFormModal?.(false, result.message)
    }
  };

  useEffect(() => {
    if (isOpen) {
    } else {
      form.setFieldsValue({
        "ZNSId": undefined,
        'chiPhi': undefined
      })
    }

  }, [isOpen])

  return (
    <Form
      form={form}
      ref={formRef}
      name="basic"
      autoComplete="off"
      className="rs-form voucher-update-form"
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Modal
        title="Thêm mẫu ZNS"
        open={isOpen}
        centered
        footer={
          [
            <span
              key="back"
              className=" cursor-pointer text-98A2B3"
            >Làm mới thông tin</span>,

            <Button
              key="submit"
              type="primary"
              onClick={submitForm}
              className="rs-button"
            >
              Lưu
            </Button>,
          ]}
        className="rs-modal w-400"
        onCancel={closeModal}
      >
        <div className="d-flex flex-column gap-18-px">
          <Form.Item
            name="ZNSId"
            rules={[{ required: true, message: 'Chọn Mẫu ZNS!' }]}
            className="m-none-form-item text-explan"
          >
            <Select
              placeholder="Mẫu ZNS"
              className="custome-select-t "

              allowClear

              options={fommatSelectOption(listTypeZNS)}
            />
          </Form.Item>



          <Form.Item
            name="chiPhi"
            validateTrigger="onChange"
            getValueFromEvent={(e) => normalizeNumberInput(e.target.value)}
            rules={[
              {
                validator: validatePositiveNumberMax12,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const orderValueMin = getFieldValue('orderValueMin');

                  if (!value || !orderValueMin) {
                    return Promise.resolve();
                  }

                  const reducedAmountRaw = String(value).replace(/\./g, '');
                  const orderValueMinRaw = String(orderValueMin).replace(/\./g, '');

                  if (!/^\d+$/.test(reducedAmountRaw) || !/^\d+$/.test(orderValueMinRaw)) {
                    return Promise.resolve();
                  }

                  const reducedAmountNumber = Number(reducedAmountRaw);
                  const orderValueMinNumber = Number(orderValueMinRaw);

                  if (reducedAmountNumber > orderValueMinNumber) {
                    return Promise.reject(
                      new Error(
                        `Số tiền giảm tối đa (${reducedAmountNumber.toLocaleString(
                          'vi-VN'
                        )}) không được lớn hơn giá trị đơn hàng tối thiểu (${orderValueMinNumber.toLocaleString(
                          'vi-VN'
                        )})!`
                      )
                    );
                  }

                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input
              placeholder="Chi phí (đ)"
              className=" rs-input--32 bg-FCFCFD border-F2F4F7"
              inputMode="numeric"
            />
          </Form.Item>

        </div>
      </Modal >
    </Form>
  )
}
export default ModalAddTemplateZNS
